//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconCommentFilled(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17 7H7V9H17V7Z" fill="currentColor" /><path d="M15 11H7V13H15V11Z" fill="currentColor" /><path d="M2 2V18H10V16H4V4H20V16H14.53L9.5 22H12.11L15.47 18H22V2H2Z" fill="currentColor" /></svg>;
}
export default IconCommentFilled;